module.exports = __webpack_public_path__ + "static/media/BG_15.9eb8ed6d.png";